import React from 'react';
import { mountOn } from './lib/mount';
import { LandingPage } from './components/landing';

mountOn('landing-root', <LandingPage/>);
